module.exports = __webpack_public_path__ + "img/values(6).a887a58f.png";